import { useEffect, useState } from 'react';
import { InputSize, InputText } from '@ui/src';
import { AccountsFlowsFormValues } from '../../../../hoc/new-application/types';
import { AccountFlowTypes } from './types';
import { CustomerStatus } from '../../../../hoc/customers/types';

import cn from './styles.module.css';

const AccountFlow = ({
  accountsFlows,
  setAccountsFlowsValues,
  accountFlow,
  currenciesList,
  status,
}: AccountFlowTypes) => {
  const [formValues, setFormValues] = useState<AccountsFlowsFormValues>();

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const nextValues = accountsFlows?.map((item) => {
      const result = { ...item };
      const nextFormValues = { ...formValues };

      if (nextFormValues.id === item.id) {
        if (e.target.name === `expectedAnnualCreditTurnover-${item.id}`) {
          nextFormValues.expectedAnnualCreditTurnover = e.target.value;
          result.expectedAnnualCreditTurnover = e.target.value;
        } else if (
          e.target.name === `maxTransferAmountPerTransaction-${item.id}`
        ) {
          nextFormValues.maxTransferAmountPerTransaction = e.target.value;
          result.maxTransferAmountPerTransaction = e.target.value;
        } else if (e.target.name === `transactionFrequency-${item.id}`) {
          nextFormValues.transactionFrequency = e.target.value;
          result.transactionFrequency = e.target.value;
        } else if (
          e.target.name === `transactionFrequencyPeriodMonths-${item.id}`
        ) {
          nextFormValues.transactionFrequencyPeriodMonths = e.target.value;
          result.transactionFrequencyPeriodMonths = e.target.value;
        }

        setFormValues(nextFormValues as AccountsFlowsFormValues);
      }

      return result;
    });

    setAccountsFlowsValues(nextValues as AccountsFlowsFormValues[]);
  };

  useEffect(() => {
    if (accountFlow) {
      setFormValues(accountFlow);
    }
  }, [accountFlow]);

  return (
    <>
      <div className={cn.formGroup}>
        <InputText
          title="Expected annual credit turnover"
          name={`expectedAnnualCreditTurnover-${accountFlow?.id}`}
          placeholder="Enter value..."
          value={formValues?.expectedAnnualCreditTurnover}
          onChange={(e) => {
            onChange({
              ...e,
              target: {
                ...e.target,
                name: `expectedAnnualCreditTurnover-${accountFlow?.id}`,
              },
            });
          }}
          disabled={status === CustomerStatus.CLOSED}
          tabIndex={status === CustomerStatus.CLOSED ? -1 : 0}
          size={InputSize.SMALL}
          currency={currenciesList?.find(
            (item) => item.id === accountFlow?.currencyId,
          )}
          amountInput
        />
      </div>
      <div className={cn.formGroup}>
        <InputText
          title="Max. transfer amount per transaction"
          name={`maxTransferAmountPerTransaction-${accountFlow?.id}`}
          placeholder="Enter value..."
          value={formValues?.maxTransferAmountPerTransaction}
          onChange={(e) => {
            onChange({
              ...e,
              target: {
                ...e.target,
                name: `maxTransferAmountPerTransaction-${accountFlow?.id}`,
              },
            });
          }}
          disabled={status === CustomerStatus.CLOSED}
          tabIndex={status === CustomerStatus.CLOSED ? -1 : 0}
          size={InputSize.SMALL}
          currency={currenciesList?.find(
            (item) => item.id === accountFlow?.currencyId,
          )}
          amountInput
        />
      </div>
      <div className={cn.formGroupTitle}>
        Frequency of transactions (months)
      </div>
      <div className={`${cn.formGroup} ${cn.formGroupFlex}`}>
        <div className={cn.formGroupFlexValue}>
          <InputText
            name={`transactionFrequency-${accountFlow?.id}`}
            placeholder="Enter number of transactions..."
            value={formValues?.transactionFrequency}
            onChange={onChange}

            disabled={status === CustomerStatus.CLOSED}
            tabIndex={status === CustomerStatus.CLOSED ? -1 : 0}
            size={InputSize.SMALL}
          />
        </div>
        <div className={cn.formGroupFlexSeparator}>per</div>
        <div className={cn.formGroupFlexValue}>
          <InputText
            name={`transactionFrequencyPeriodMonths-${accountFlow?.id}`}
            placeholder="Number of months..."
            value={formValues?.transactionFrequencyPeriodMonths}
            onChange={onChange}

            disabled={status === CustomerStatus.CLOSED}
            tabIndex={status === CustomerStatus.CLOSED ? -1 : 0}
            size={InputSize.SMALL}
          />
        </div>
      </div>
    </>
  );
};

export default AccountFlow;
